module.exports = __webpack_public_path__ + "img/mobile-menu-dark.e53ccaa2.svg";